<template>
  <div class="full-height">
    <v-card-title>
      <v-flex tag="h3">
        Case Crew
      </v-flex>
    </v-card-title>

    <v-list class="no-padding">
      <v-divider></v-divider>
      <v-list-tile ripple class="auth-height">
        <v-flex xs4 md2>
          <h5><b>Event Pallbearers</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          <v-select
            :disabled="disabled.caseCrewSelect || closed"
            :items="servicesList | filterPallBearers(0)"
            v-model="selectedEventPallbearers"
            item-text="description"
            attach
            chips
            clearable
            multiple
            class="case-crew-select"
            @blur="updatePallbearers(0)"
          >
            <template slot="item" slot-scope="props">
              {{ props.item.name }} - {{ props.item.description }}
            </template>
            <template slot="selection" slot-scope="props">
              <span class="v-chip v-chip--select-multi theme--light">
                <span class="v-chip__content">
                  {{ props.item.name }} - {{ props.item.description }}
                </span>
              </span>
            </template>
          </v-select>
        </v-flex>
      </v-list-tile>
    </v-list>

    <v-list class="no-padding">
      <v-divider></v-divider>
      <v-list-tile ripple class="auth-height">
        <v-flex xs4 md2>
          <h5><b>Closing Pallbearers</b></h5>
        </v-flex>
        <v-flex xs9 md10>
          <v-select
            :disabled="disabled.caseCrewSelect || closed"
            :items="servicesList | filterPallBearers(1)"
            v-model="selectedClosingPallbearers"
            item-text="description"
            attach
            chips
            clearable
            multiple
            class="case-crew-select"
            @blur="updatePallbearers(1)"
          >
            <template slot="item" slot-scope="props">
              {{ props.item.name }} - {{ props.item.description }}
            </template>
            <template slot="selection" slot-scope="props">
              <span class="v-chip v-chip--select-multi theme--light">
                <span class="v-chip__content">
                  {{ props.item.name }} - {{ props.item.description }}
                </span>
              </span>
            </template>
          </v-select>
        </v-flex>
      </v-list-tile>
    </v-list>

  </div>
</template>

<script>
  import casesAPI from '@/api/resources/cases'
  import schedulesAPI from '@/api/resources/schedules'
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        selectedEventPallbearers: [],
        selectedClosingPallbearers: [],
        disabled: {
          caseCrewSelect: false
        },
        leadsUuid: null
      }
    },
    props: {
      caseid: {
        type: Number,
        required: true
      },
      case: {
        type: Object
      }
    },
    computed: {
      ...mapGetters({
        getEditCrewCaseId: 'getEditCrewCaseId',
        servicesList: 'allServices'
      }),
      closed () {
        return this.case.status === 'closed'
      }
    },
    filters: {
      filterPallBearers (value, closing) {
        return value.filter(service => service.hasOwnProperty('description') && service.description !== null
          ? service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') === 'casecrew'
          : false
        )
      }
    },
    watch: {
      users () {
        this.$store.dispatch('getCaseManager', this.caseid)
      }
    },
    mounted () {
      casesAPI.getLead(this.caseid).then(result => {
        this.leadsUuid = result[0].leads_id
        this.selectedEventPallbearers = result
          .filter(filtering => filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 0)
          .map(item => { return item.item_id })
        this.selectedClosingPallbearers = result
          .filter(filtering => filtering.service.description.toLowerCase().replace(/\s/g, '').replace(/-/g, '') !== 'casemanager' && filtering.is_closing === 1)
          .map(item => { return item.item_id })
      }, () => {})
    },
    methods: {
      updatePallbearers (closing) {
        this.disabled.caseCrewSelect = true

        const pallbearers = closing ? this.selectedClosingPallbearers : this.selectedEventPallbearers

        schedulesAPI.updatePallbearers(this.leadsUuid, pallbearers, closing).then(() => {
          this.$store.dispatch('getCaseLog', this.caseid)
          setTimeout(() => {
            this.disabled.caseCrewSelect = false
          }, 1000)
        }, () => {})
      }
    }
  }
</script>

<style>
  .full-height {
    height: 100%;
  }
  .case-crew-select {
    margin: 20px 0 0;
    padding: 0;
  }
  .case-crew-select .v-input__slot:before {
    border-color: transparent !important;
  }
  .case-crew-select .v-input__slot .v-input__append-inner {
    margin-top: 9px;
  }
  .no-padding {
    padding: 0;
  }
  .auth-height,
  .auth-height .v-list__tile {
    height: auto !important;
  }
</style>



// WEBPACK FOOTER //
// CaseCrewDataTable.vue?b772e538